module.exports = __webpack_public_path__ + "static/media/町田君的世界.1c74daa6.jpg";